import Type from './Type.vue'
import Close from './Close.vue'
import Time from './Time.vue'
import excludeStatus from './excludeStatus.vue'
import TimeHeader from './TimeHeader.vue'

// 工厂函数：每次调用都重新求值 $t(...)，配合组件 computed 实现语言切换时表头实时更新
export function getColumns() {
  return [
    {
      title: $t('public.table_scope'),
      index: 'sceneName'
    },
    {
      title: $t('integration.ir_carrier'),
      index: 'carrierName',
    },
    {
      title: $t('integration.ir_installation_point'),
      index: 'carrierDeviceName'
    },
    {
      title: $t('integration.exclude_abnormal'),
      index: 'excludeStatus',
      component: excludeStatus,
      width: '145px'
    },
    {
      title: $t('integration.ir_type'),
      index: 'exCatalog',
      component: Type
    },
    {
      // 表头专用 key（ir_close_header=关闭/Closed），不影响搜索栏的"是否关闭"
      title: $t('integration.ir_close_header'),
      index: 'status',
      component: Close,
      width: '90px'
    },
    {
      title: $t('integration.ir_abnormal_time'),
      index: 'happenTime',
      dataType: 'time',
      width: '180px'
    },
    {
      title: $t('integration.continued') + '/' + $t('integration.closing_time'),
      index: 'closeTime',
      component: Time,
      width: '180px',
      headerComponent: TimeHeader
    },
  ]
}
